import { render, staticRenderFns } from "./assistance.vue?vue&type=template&id=0df8d63c"
import script from "./assistance.vue?vue&type=script&lang=ts"
export * from "./assistance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports